import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import store from './store'

Vue.use(VueRouter)

const router = new VueRouter({ mode: 'history', routes: routes })

// Check if the user is authorized to access the route
router.beforeEach((to, from, next) => {
  store.dispatch('auth/check').then(() => {
    const passedEntitlements = to.matched
      .filter(route => route.meta.can)
      .map(route => store.getters['auth/entitlements'].can(route.meta.can))
      .reduce((passed, routeStatus) => passed && routeStatus, true)

    if (to.matched.some(m => m.meta.auth) && store.state.auth.authenticated && to.matched.some(m => m.meta.can) && !passedEntitlements) {
      next({ name: 'home' })
    } else if (to.matched.some(m => m.meta.auth) && !store.state.auth.authenticated) {
      next({ name: 'login', query: { cognitoCode: to.query.code } })
    } else if (to.matched.some(m => m.meta.guest) && store.state.auth.authenticated) {
      next({ name: 'home' })
    } else if (to.redirectedFrom && to.matched.some(m => m.meta.guest)) {
      next({ name: 'login', query: { mckidCode: to.hash.match(/code=(.*)/)[1] } })
    } else {
      next()
    }
  })
})

export default router
